module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./~/_dva-core@1.4.0@dva-core/index.js
// module id = 393
// module chunks = 6